module.exports = __webpack_public_path__ + "img/free.43565561.png";